import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import 'toastr/build/toastr.min.css';
import close from '../assets/img/icons/close.svg';
import Header from './Header';
import Tabs from './Tabs';
import ManageTab from './Manage';

import '../assets/css/style.css';
import AppointmentForm from './forms/AppointmentForm';
import * as QueryString from 'query-string';

/**
 * Booking Component
 */
class Booking extends Component {
  /**
   * Constructor
   * @param {{history}|object} props - Component props
   */
  constructor(props) {
    super(props);
    this.callbackFunction = this.callbackFunction.bind(this);
    this.closeError = this.closeError.bind(this);
    this.go2Booking = this.go2Booking.bind(this);
    this.go2Terms = this.go2Terms.bind(this);

    this.state = {
      // Legacy
      stickyErr: 'false',
      stickySuccess: 'false',
      errorMessage: '',
      successMessage: '',
      loading: false,
    };

    const {refNum, serviceNum = ''} = QueryString.parse(props.location.search);
    this.activeTab = refNum ? 1 : 0;
    this.serviceNum = parseInt(serviceNum);
  }

  /**
   * Callback function - actually is a function to show notification
   * @param{'success'|'error'} status - status of notification
   * @param{string} message - Message to show
   */
  callbackFunction(status, message) {
    if (status === 'success') {
      this.setState({stickySuccess: 'true'});
      this.setState({successMessage: message});
    }
    if (status === 'error') {
      this.setState({stickyErr: 'true'});
      this.setState({errorMessage: message});
    }
  }

  /**
   * Close Error - Actually it's closing notification
   */
  closeError() {
    this.setState({
      stickyErr: 'false',
      stickySuccess: 'false',
    });
  }

  /**
   * Go to Terms - Redirect the page to term page
   * @param{any} _
   */
  go2Terms(_) {
    this.props.history.push('/page/appointment/terms');
  }

  /**
   * Go to Booking - Redirect the page to booking page
   * @param{any} _
   */
  go2Booking(_) {
    window.location.reload(false);
  }

  /**
   * render - Rendering function of React component
   * @return {JSX.Element}
   */
  render() {
    const stickyErr = this.state.stickyErr;
    const stickySuccess = this.state.stickySuccess;

    if (stickyErr === 'true') {
      setTimeout(() => {
        this.setState({stickyErr: 'false'});
      }, 3000);
    }
    let errDiv;
    if (stickyErr === 'true') {
      errDiv = <div className="sticky_div">
        <div className='row'>
          <div>
            <span style={{
              float: 'right',
              paddingRight: '30px',
              paddingTop: '5px',
              cursor: 'pointer',
            }}>
              <img alt={'x'} src={close} onClick={this.closeError}/>
            </span>
          </div>
          <div style={{paddingTop: '40px'}}>
            <span>{this.state.errorMessage}</span>
          </div>
        </div>
      </div>;
    }
    if (stickySuccess === 'true') {
      setTimeout(() => {
        this.setState({stickySuccess: 'false'});
      }, 3000);
    }
    let succDiv;
    if (stickySuccess === 'true') {
      succDiv = <div className="sticky_div_succ">
        <div className='row'>
          <div>
            <span style={{
              float: 'right',
              paddingRight: '30px',
              paddingTop: '5px',
              cursor: 'pointer',
            }}>
              <img alt={'x'} src={close}
                onClick={this.closeError}/>
            </span>
          </div>
          <div style={{paddingTop: '40px'}}>
            <span>{this.state.successMessage}</span>
          </div>
        </div>
      </div>;
    }

    return <div className="page">
      <div className="">
        <Header/>
        <div className={'col-md-offset-3 col-lg-offset-3 col-sm-offset-2 ' +
        'col-md-6 col-lg-6 col-sm-8 main-div'}>
          <Tabs active={this.activeTab}>
            NEW
            <div className="row">
              <div className="col-md-12" style={{padding: 0}}>
                <AppointmentForm
                  serviceNum={this.serviceNum}
                  handleLoading={(loading) => {
                    this.setState({loading});
                  }} changePage={(uri) => {
                    this.props.history.push(uri);
                  }} submitError={({errorMessage}) => {
                    this.setState({loading: false});
                    this._reCaptchaRef && this._reCaptchaRef.reset();
                    this.setState({
                      stickyErr: 'true',
                      errorMessage,
                    });
                  }}/>
              </div>
            </div>
            MANAGE
            <ManageTab parentCallback={this.callbackFunction}/>
          </Tabs>
        </div>
        {errDiv} {succDiv}
      </div>
      {!this.state.loading || <div className="loader"/>}
    </div>;
  }
}

Booking.propTypes = {
  history: PropTypes.object,
};

const mapDispatchToProps = () => ({});
const mapStateToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Booking);
